/* global G */
/**
 * Applies the accumulated filters by mutating the `list`'s `G.META` and
 * recreates the view.
 *
 * @param {Gaia.AppModule.Spec} module the ticket module composition object
 * @returns {function(*, {filter?: {}}=, ...[*]): Promise<*[]>}
 */
export default module => async (children, { filter = {} } = {}, ...args) => {
  const { list } = children

  const meta = list[G.STATE][G.META] || {}

  const hasFilter = Object.keys(filter).find(f => !!filter[f])

  // Reset pagination
  list[G.STATE][G.NEXT] = undefined
  list[G.STATE][G.META] = { ...meta, filter }

  if (hasFilter) {
    list[G.STATE].page = null
    list[G.STATE].data = null
  }

  list[G.STATE].reload = {}

  await module[G.ADAPTER][G.UI].update(module)

  return args
}
